import { createIntl, createIntlCache } from 'react-intl';
import enGB from '../utility/lang/en-GB';

export const cache = createIntlCache();

export default {
  intl: createIntl({ locale: enGB.locale, messages: enGB.messages }, cache),
};
